import React from 'react';
import { useFadeIn } from '../hooks/useFadeIn';
export function IncludedSection() {
  const fadeIn = useFadeIn();
  return <section className="py-16 px-4 bg-white" data-id="element-109">
      <div className="max-w-3xl mx-auto" data-id="element-110">
        <div ref={fadeIn.ref} className={fadeIn.className} data-id="element-111">
          <div className="text-center mb-12" data-id="element-112">
            <h2 className="text-3xl md:text-5xl font-black text-gray-900 mb-4" data-id="element-113">
              💙 Qué incluye cada tomo y qué vas a lograr
            </h2>
            <div className="w-24 h-2 bg-blue-600 mx-auto rounded-full" data-id="element-114"></div>
          </div>

          <div className="space-y-12" data-id="element-115">
            {/* Qué vas a recibir */}
            <div data-id="element-116">
              <h3 className="text-2xl font-black text-blue-600 mb-6 border-b-2 border-blue-100 pb-2" data-id="element-117">
                📚 Cada tomo incluye:
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-118">
                <div className="bg-blue-50 p-4 rounded-xl flex gap-3 items-start border border-blue-100" data-id="element-119">
                  <span className="text-2xl" data-id="element-120">✅</span>
                  <p className="text-blue-900 font-medium" data-id="element-121">
                    Actividades prácticas listas para usar
                  </p>
                </div>
                <div className="bg-blue-50 p-4 rounded-xl flex gap-3 items-start border border-blue-100" data-id="element-122">
                  <span className="text-2xl" data-id="element-123">📝</span>
                  <p className="text-blue-900 font-medium" data-id="element-124">
                    Ejercicios guiados paso a paso
                  </p>
                </div>
                <div className="bg-blue-50 p-4 rounded-xl flex gap-3 items-start border border-blue-100" data-id="element-125">
                  <span className="text-2xl" data-id="element-126">💬</span>
                  <p className="text-blue-900 font-medium" data-id="element-127">
                    Lenguaje adaptado a adolescentes de 12 a 18 años
                  </p>
                </div>
                <div className="bg-blue-50 p-4 rounded-xl flex gap-3 items-start border border-blue-100" data-id="element-128">
                  <span className="text-2xl" data-id="element-129">🏠</span>
                  <p className="text-blue-900 font-medium" data-id="element-130">
                    Recursos para usar en casa, aula o consultorio
                  </p>
                </div>
                <div className="bg-blue-50 p-4 rounded-xl flex gap-3 items-start border border-blue-100 md:col-span-2" data-id="element-131">
                  <span className="text-2xl" data-id="element-132">⚡</span>
                  <p className="text-blue-900 font-medium" data-id="element-133">
                    Herramientas de aplicación inmediata — sin formación previa
                    en psicología
                  </p>
                </div>
              </div>
            </div>

            {/* Qué vas a lograr con tu familia */}
            <div data-id="element-134">
              <h3 className="text-2xl font-black text-blue-600 mb-6 border-b-2 border-blue-100 pb-2" data-id="element-135">
                ¿Qué vas a lograr con tu hijo/a?
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-136">
                <div className="bg-blue-50 p-4 rounded-xl flex gap-3 items-start border border-blue-100" data-id="element-137">
                  <span className="text-2xl" data-id="element-138">💬</span>
                  <p className="text-gray-700 font-medium" data-id="element-139">
                    Conversaciones reales sin que se cierre o explote
                  </p>
                </div>
                <div className="bg-blue-50 p-4 rounded-xl flex gap-3 items-start border border-blue-100" data-id="element-140">
                  <span className="text-2xl" data-id="element-141">🧠</span>
                  <p className="text-gray-700 font-medium" data-id="element-142">
                    Que identifique y nombre lo que siente antes de reaccionar
                  </p>
                </div>
                <div className="bg-blue-50 p-4 rounded-xl flex gap-3 items-start border border-blue-100" data-id="element-143">
                  <span className="text-2xl" data-id="element-144">💖</span>
                  <p className="text-gray-700 font-medium" data-id="element-145">
                    Fortalecer la confianza y la comunicación entre ustedes
                  </p>
                </div>
                <div className="bg-blue-50 p-4 rounded-xl flex gap-3 items-start border border-blue-100" data-id="element-146">
                  <span className="text-2xl" data-id="element-147">🛡️</span>
                  <p className="text-gray-700 font-medium" data-id="element-148">
                    Protección emocional frente a redes sociales y presión
                    social
                  </p>
                </div>
                <div className="bg-blue-50 p-4 rounded-xl flex gap-3 items-start border border-blue-100 md:col-span-2" data-id="element-149">
                  <span className="text-2xl" data-id="element-150">🌈</span>
                  <p className="text-gray-700 font-medium" data-id="element-151">
                    Un plan de bienestar emocional personalizado para su vida
                    diaria
                  </p>
                </div>
              </div>
            </div>

            {/* Qué vas a lograr vos */}
            <div data-id="element-152">
              <h3 className="text-2xl font-black text-yellow-500 mb-6 border-b-2 border-yellow-100 pb-2" data-id="element-153">
                ¿Qué vas a lograr vos como adulto acompañante?
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-154">
                <div className="bg-yellow-50 p-4 rounded-xl flex gap-3 items-start border border-yellow-100" data-id="element-155">
                  <span className="text-2xl" data-id="element-156">✨</span>
                  <p className="text-gray-700 font-medium" data-id="element-157">
                    Saber exactamente qué hacer en una crisis emocional
                  </p>
                </div>
                <div className="bg-yellow-50 p-4 rounded-xl flex gap-3 items-start border border-yellow-100" data-id="element-158">
                  <span className="text-2xl" data-id="element-159">🧠</span>
                  <p className="text-gray-700 font-medium" data-id="element-160">
                    Entender por qué reacciona así y cómo responder diferente
                  </p>
                </div>
                <div className="bg-yellow-50 p-4 rounded-xl flex gap-3 items-start border border-yellow-100" data-id="element-161">
                  <span className="text-2xl" data-id="element-162">💞</span>
                  <p className="text-gray-700 font-medium" data-id="element-163">
                    Reconstruir el vínculo sin que sienta que lo controlás
                  </p>
                </div>
                <div className="bg-yellow-50 p-4 rounded-xl flex gap-3 items-start border border-yellow-100" data-id="element-164">
                  <span className="text-2xl" data-id="element-165">🎯</span>
                  <p className="text-gray-700 font-medium" data-id="element-166">
                    Herramientas listas para usar sin ser psicólogo
                  </p>
                </div>
                <div className="bg-yellow-50 p-4 rounded-xl flex gap-3 items-start border border-yellow-100 md:col-span-2" data-id="element-167">
                  <span className="text-2xl" data-id="element-168">🌟</span>
                  <p className="text-gray-700 font-medium" data-id="element-169">
                    Convertirte en el adulto que tu hijo necesita en este
                    momento
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}